import styled from 'styled-components';

const defaultStyle = `
  font-family: 'Lato', 'DefaultLato', 'sans-serif';
  font-size: 16px;
  font-weight: 600;
`;

export const Title = styled.div`
  color: #666666;
  line-height: 1.4;
  margin-bottom: 8px;
  ${defaultStyle}
`;

export const Text = styled.div`
  font-size: 15px;
  margin-bottom: 10px;
`;

export const ClassroomList = styled.ul`
  margin: 0 0 8px;
  padding-left: 20px;
  line-height: 1.4;
`;

export const Classroom = styled.li`
  color: #999999;
  margin: 4px 0;
  ${defaultStyle}
`;

export const Warning = styled.div`
  color: #f05060;
  line-height: 1.4;
  margin: 8px 0 10px;
  ${defaultStyle}
`;

export const UnassignedClassroom = styled.li`
  color: #cccccc;
  margin: 4px 0;
  ${defaultStyle}
`;

export const DesyncButton = styled.div`
  border-radius: 5px;
  width: 116px;
  height: 40px;
  color: white;
  background-color: #f05060;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  &:hover {
    cursor: pointer;
  }
  ${defaultStyle}
`;
